// extracted by mini-css-extract-plugin
export default {"exclusionsSection":"TripExclusion_exclusionsSection__7ac8N","exclusionsTitle":"TripExclusion_exclusionsTitle__Eq10v","exclusionsList":"TripExclusion_exclusionsList__nmsN8"};